import styled from "styled-components";
import { StyledGlobalMainContainer } from "../globalStyle";

export const StyledContainer = styled(StyledGlobalMainContainer)`
  margin-top: 76px;
  @media (max-width: 768px) {
    padding: 0 22px 22px;
    margin-top: 99px;
  }
  @media (max-width: 425px) {
    padding: 0 22px 22px;
    margin-top: 76px;
  }
`;

export const StyledTitleContainer = styled.div`
  display: grid;
  justify-items: center;
  grid-row-gap: 39px;
  h1 {
    text-align: start;
  }
`;

export const StyledDescription = styled.div`
  margin-top: 41px;
  display: grid;
  justify-items: center;
  align-items: center;
`;

export const StyledMainContainer = styled.div`
  display: grid;
  grid-column-gap: 91px;
  grid-row-gap: 16px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
    margin-top: 63px;
  }
  @media (max-width: 768px) {
    margin-top: 36px;
  }
`;

export const StyledGroupInner = styled.div`
  display: grid;
  grid-row-gap: 16px;
  grid-auto-rows: max-content;
`;

export const StyledInnerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 64px;
  gap: 16px 30px;
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    grid-row-gap: 16px;
  }
`;
